import { useEffect } from 'react';

interface UnlockToastProps {
  label: string;
  note: string;
  onDone: () => void;
}

/** The badge moment. Announced politely, gone in four seconds. */
export default function UnlockToast({ label, note, onDone }: UnlockToastProps) {
  useEffect(() => {
    const timer = window.setTimeout(onDone, 4000);
    return () => window.clearTimeout(timer);
  }, [label, onDone]);

  return (
    <div className="unlock" role="status" aria-live="polite">
      <span className="ui" aria-hidden="true">
        ◆
      </span>
      <div>
        <div className="ul">Unlocked · {label}</div>
        <div className="un">{note}</div>
      </div>
    </div>
  );
}
